import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.788 3.946c.448-1.078 1.975-1.078 2.424 0l2.082 5.006 5.404.433c1.164.093 1.636 1.546.749 2.305l-4.117 3.527 1.258 5.274c.271 1.136-.965 2.033-1.961 1.425L12 19.089l-4.627 2.826c-.996.609-2.232-.289-1.961-1.425l1.258-5.273-4.117-3.527c-.887-.759-.415-2.212.749-2.305l5.404-.433z"
}));
const ForwardRef = forwardRef(SvgComponent);
export const StarSolidIcon = ForwardRef;